export default __webpack_public_path__ + "static/media/div_img_2.1264ff38.svg";